export default __webpack_public_path__ + "static/media/portfolio1.624ff0ef.jpg";